
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.828 3.031c-.213-.828-.443-1.37-.687-1.625-.24-.26-.57-.39-.993-.39h-2.32v8c0 .505.052.872.156 1.101.105.23.404.396.899.5V11H.445v-.383c.407-.11.662-.247.766-.414.11-.172.164-.557.164-1.156V2.266c0-.693-.068-1.11-.203-1.25C1.036.875.794.763.445.68V.297h7.118V3.03h-.735z","fill":"currentColor"}})])
          )
        }
      }
    